
import { localization as state } from '@/main/localization';

import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

export const localization = {
	state,
	getters,
	mutations,
	actions,
};
